import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
const WORD = 'recall';
/** Easter egg: typing "recall" anywhere fires a one-shot fullscreen sonar ping. */
export function MagicWord() {
  const [pings, setPings] = useState<number[]>([]);
  useEffect(() => {
    let buffer = '';
    const onKey = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement | null;
      if (target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable)) return;
      if (e.key.length !== 1) return;
      buffer = (buffer + e.key.toLowerCase()).slice(-WORD.length);
      if (buffer === WORD) {
        buffer = '';
        setPings(p => [...p, Date.now()]);
        window.dispatchEvent(new CustomEvent('recall:magic-word'));
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);
  return <div aria-hidden="true" className="pointer-events-none fixed inset-0 z-[90] flex items-center justify-center overflow-hidden" data-id="element-304">
      <AnimatePresence data-id="element-305">
        {pings.map(id => <motion.span key={id} initial={{
        scale: 0,
        opacity: 0.4
      }} animate={{
        scale: 1,
        opacity: 0
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 2.2,
        ease: 'easeOut'
      }} onAnimationComplete={() => setPings(p => p.filter(x => x !== id))} className="absolute h-[250vmax] w-[250vmax] rounded-full border border-teal-600 will-change-transform" data-id="element-306" />)}
      </AnimatePresence>
    </div>;
}